import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {MemberBackgroundData} from '../models/member-background-data';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MemberBackgroundService {

  constructor (private db: AngularFirestore) { }

  select () {
    return this.db.collection<MemberBackgroundData>('sbccv_members_background', ref => ref
      .orderBy('date', 'asc')).snapshotChanges();
  }

  load () {
    return this.db.collection<MemberBackgroundData>('sbccv_members_background', ref => ref
      .orderBy('date', 'asc')).get();
  }

  loadByName () {
    return this.db.collection<MemberBackgroundData>('sbccv_members_background', ref => ref
      .orderBy('member_name', 'asc')
      .orderBy('date', 'asc')).get();
  }

  selectByMemberId (memberId: string) {
    return this.db.collection<MemberBackgroundData>('sbccv_members_background', ref => ref
      .where("member_id", "==", memberId)
      .orderBy('dateStart', 'desc'))
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          return {
            ...data,
            id,
            // Tratamento seguro de datas
            dateStart: data.dateStart?.toDate() || null,
            dateEnd: data.dateEnd?.toDate() || null
          } as MemberBackgroundData;
        }))
      );
  }

  insert (entity: MemberBackgroundData) {
    return this.db.collection('sbccv_members_background').add(Object.assign({}, entity));
  }

  update (entity: MemberBackgroundData) {
    return this.db.collection('sbccv_members_background')
      .doc(entity.id)
      .set(Object.assign({}, entity), {'merge': true});
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_members_background').doc(entity_id).delete();
  }

  createEntity (data) {
    const entity = new MemberBackgroundData()
    entity.id = data.id;
    entity.member_id = data.member_id;
    entity.member_name = data.member_name;
    entity.dateStart = data.dateStart;
    entity.dateEnd = data.dateEnd;
    entity.location = data.location;
    entity.text = data.text;

    return entity
  }

}


